import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import App from "./App";
import {AppProviders} from "./app/providers";
import * as Sentry from "@sentry/react";
import "./styles/tailwind.css";
import "./styles/globals.css";

const disableUserZoom = () => {
  const preventDefault = (event: Event) => {
    event.preventDefault();
  };

  document.addEventListener("gesturestart", preventDefault, {passive: false});
  document.addEventListener("gesturechange", preventDefault, {passive: false});
  document.addEventListener("gestureend", preventDefault, {passive: false});
};

disableUserZoom();

Sentry.init({
  dsn: "https://a8bd9d465b354da779d3e4ca94a2dae1@o4508478671880192.ingest.de.sentry.io/4511086488584272",
  sendDefaultPii: true,
});

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>,
);
